import { render, staticRenderFns } from "./EndpointAccessRights.vue?vue&type=template&id=09b5da88&scoped=true&"
import script from "./EndpointAccessRights.vue?vue&type=script&lang=ts&"
export * from "./EndpointAccessRights.vue?vue&type=script&lang=ts&"
import style0 from "./EndpointAccessRights.vue?vue&type=style&index=0&id=09b5da88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5da88",
  null
  
)

export default component.exports